<template>
  <div>
    <div class="mb-3">
      <label for="">{{ 'Header' | translate }}</label>
      <input
        class="form-control"
        type="text"
        v-model="block.header"
        :placeholder="$t('Header')"
        maxlength="200"
      />
    </div>

    <hr />
    <draggable :list="faqs" handle=".grabbable">
      <div class="card mb-3" v-for="(faq, index) in faqs" :key="index">
        <div class="card-header d-flex justify-content-between">
          <i class="fas fa-bars grabbable"></i>
          <button @click="deleteFaq(index)" class="btn btn-outline-danger btn-sm">
            {{'Delete' | translate}}
          </button>
        </div>
        <div class="card-body">
          <div class="mb-3">
            <label>{{ 'Question' | translate }}</label>
            <input
              class="form-control"
              type="text"
              v-model="faq.question"
              :placeholder="$t('Question')"
            />
          </div>
          <div class="mb-3">
            <label>{{ 'Answer' | translate }}</label>
            <textarea class="form-control" cols="30" rows="3" v-model="faq.answer"></textarea>
            <div class="form-text">{{ 'You can use Markdown here' | translate }}.</div>
          </div>
        </div>
      </div>
    </draggable>

    <div class="row">
      <div class="col">
        <button @click="addFaq" class="btn btn-primary">
          {{ 'Add' | translate }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  components: {
    draggable,
  },
  props: ['block'],
  data() {
    return {
      faqs: [...this.block.data],
    }
  },
  updated() {
    this.updateBlock()
  },
  methods: {
    deleteFaq(key) {
      this.$delete(this.faqs, key)
    },
    addFaq() {
      this.faqs.push({
        question: null,
        answer: null,
      })
    },
    updateBlock() {
      this.block.data = this.faqs
    },
  },
}
</script>
